const MenuOverlayToggler = () => {

	const toggleBtn = document.querySelector('#menu-overlay-toggler');
	if(!toggleBtn) {
		return;
	}

	toggleBtn.addEventListener('click', (e) => {
		e.preventDefault();
		document.body.classList.toggle('js-menu-overlay-revealed');

		if(document.body.classList.contains('js-menu-overlay-revealed')) {
			toggleBtn.setAttribute('aria-haspopup', 'true');
			toggleBtn.setAttribute('aria-expanded', 'true');
			toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelOpened);
		}
		else {
			toggleBtn.removeAttribute('aria-haspopup');
			toggleBtn.removeAttribute('aria-expanded');
			toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelClosed);
		}
	});
};

export default MenuOverlayToggler;